// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JxU8","placeholder":"styles_placeholder__1m3gl","placeholderOption":"styles_placeholderOption__1pQtB"};